/**
 *
 * MainButton.js
 *
 * A common button, if you pass it a prop "route" it'll render a link to a react-router route
 * otherwise it'll render a link with an onclick
 */

import React, { Children } from 'react';
import PropTypes from 'prop-types';

// import A from './A';
// import StyledButton from './StyledButton';
import Wrapper from './Wrapper';

function MainButton(props) {
  // Render an anchor tag
//   let button = (
//     <A href={props.href} onClick={props.onClick}>
//       {Children.toArray(props.children)}
//     </A>
//   );

  // If the Button has a handleRoute prop, we want to render a button
//   if (props.handleRoute) {
  let button = (
    <div onClick={props.handleRoute}>
        {Children.toArray(props.children)}
    </div>
  );
  if ( props.type && props.type === 'submit'){
    button = (
      <div onClick={props.handleRoute}>
        <button className="submitBtn" type="submit">
          {Children.toArray(props.children)}
        </button>
      </div>
    );
  } 
    
//   }

  return (
    <Wrapper>
      {button}
    </Wrapper>
  );
}

MainButton.propTypes = {
  handleRoute: PropTypes.func,
  href: PropTypes.string,
  onClick: PropTypes.func,
//   children: PropTypes.node.isRequired,
};

export default MainButton;



// WEBPACK FOOTER //
// ./src/components/MainButton/index.js